export default __webpack_public_path__ + "static/media/6a0457e3-5606-4bf1-a8ed-ade0a5dc3485.98dfd211.webp";